export default "__VITE_ASSET__mJ6XICZJ__"